export const PHONE_SUFFIX_LENGTH = 10;

export function normalizePhoneNumber(value: string): string {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function phoneSuffixKey(normalizedNumber: string): string {
  const digitsOnly = normalizePhoneNumber(normalizedNumber);
  if (!digitsOnly) return '';
  if (digitsOnly.length <= PHONE_SUFFIX_LENGTH) return digitsOnly;
  return digitsOnly.slice(-PHONE_SUFFIX_LENGTH);
}

export function commonSuffixLength(a: string, b: string): number {
  const first = normalizePhoneNumber(a);
  const second = normalizePhoneNumber(b);
  let i = 0;
  while (i < first.length && i < second.length) {
    if (first[first.length - 1 - i] !== second[second.length - 1 - i]) break;
    i++;
  }
  return i;
}
